<script lang="ts">
  import {onMount} from 'svelte';

  import {API_KEY, DISCOVERY_DOCS} from '../../configs/google';

  const loadGoogleApis = () => {
    const scriptTag = document.createElement('script');
    scriptTag.setAttribute('type', 'text/javascript');
    scriptTag.setAttribute('async', 'async');
    scriptTag.setAttribute('defer', 'defer');
    scriptTag.setAttribute('src', 'https://apis.google.com/js/api.js');
    scriptTag.onload = () => {
      handleClientLoad();
    };
    document.getElementsByTagName('head')[0].appendChild(scriptTag);
  };

  const handleClientLoad = () => {
    gapi.load('client', initClient);
  };

  const initClient = () => {
    gapi.client.init({
      apiKey: API_KEY,
      discoveryDocs: DISCOVERY_DOCS
    });
  };

  onMount(loadGoogleApis);
</script>
